<template>
  <div class="doctor-consult big">
    <div class="page_title">医生资讯列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="margin-bottom: 20px">
          <el-button
            type="primary"
            icon="el-icon-plus"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('577') : false
            "
            @click="infoClassifyClick"
            >资讯分类</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('573') : false
            "
            @click="addInfo"
            >添加资讯</el-button
          >
        </div>
        <div class="search-box">
          <!-- 标题 -->
          <div class="item">
            <span>标题</span>
            <div class="item-content">
              <el-input
                v-model="searchForm.title"
                size="small"
                clearable
                placeholder="标题"
              ></el-input>
            </div>
          </div>

          <!-- 发布时间 -->
          <div class="item">
            <span style="margin-left: 10px">发布时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="searchForm.times"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 状态 -->
          <div class="item">
            <span style="margin-left: 10px">状态</span>
            <div class="item-content">
              <el-select
                v-model="searchForm.status"
                size="small"
                placeholder="请选择"
                @change="searchList"
              >
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="searchList"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="doctorTableRef"
            class="doctor-table"
            :data="doctorTableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              align="center"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'status'" class="doctor-status">
                  <i :style="stateStyle(scope.row[item.prop])"></i>
                  {{ scope.row[item.prop] | stateText }}
                </div>

                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column label="阅读量" prop="read_num" align="center">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('617')
                      : false
                  "
                  @click="readNumClick(scope.row)"
                  >{{ scope.row.read_num
                  }}<i class="el-icon-view el-icon--right"></i>
                </el-link>
              </template>
            </el-table-column>

            <el-table-column
              label="阅读量(实际)"
              width="120px"
              prop="real_read_num"
              align="center"
            >
            </el-table-column>

            <el-table-column label="操作" width="140px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status != 2"
                  @click="infoEdit(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('574')
                      : false
                  "
                  size="medium"
                  >编辑</el-button
                >

                <el-button
                  v-if="scope.row.status != 1 && scope.row.status != 3"
                  @click="infoDetail(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('574')
                      : false
                  "
                  size="medium"
                  >详情</el-button
                >

                <el-button
                  v-if="scope.row.status != 2"
                  @click="changeStatus(scope.row, 2)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('575')
                      : false
                  "
                  size="medium"
                  >发布</el-button
                >

                <el-button
                  v-if="scope.row.status != 1 && scope.row.status != 3"
                  @click="changeStatus(scope.row, 3)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('575')
                      : false
                  "
                  size="medium"
                  >下架</el-button
                >

                <el-button
                  v-if="scope.row.status == 1 || scope.row.status == 3"
                  @click="infoDel(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('576')
                      : false
                  "
                  size="medium"
                  >删除</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="排序" width="200px" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="置顶"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 1)"
                    size="medium"
                    type="text"
                    icon="el-icon-upload2"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('572')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="置底"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 4)"
                    size="medium"
                    type="text"
                    icon="el-icon-download"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('572')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="上移"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 2)"
                    size="medium"
                    type="text"
                    icon="el-icon-top"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('572')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="下移"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 3)"
                    size="medium"
                    type="text"
                    icon="el-icon-bottom"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('572')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="searchList"
        />
      </div>
    </div>
    <!-- 修正阅读量 -->
    <el-dialog
      title="修正阅读量"
      :visible.sync="readDialog"
      width="400px"
      center
      custom-class="read-dialog"
    >
      <el-form :model="readForm" :rules="readFormRules">
        <el-form-item label="阅读量:" label-width="100px" prop="read_num">
          <el-input-number
            class="read-number"
            v-model="readForm.read_num"
            :controls="false"
            :min="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="readDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmRead">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import imgtext from "../../../api/imgtext";
import Pagination from "../../../components/Pagination/index";
import dayjs from "dayjs";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      searchForm: {
        title: "",
        status: 0,
        times: [],
      },
      selectOptions: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "待发布",
          value: 1,
        },
        {
          label: "已发布",
          value: 2,
        },
        {
          label: "下架",
          value: 3,
        },
      ],
      tableHeader: [
        {
          label: "标题",
          prop: "title",
          width: "auto",
        },
        {
          label: "内容简介",
          prop: "summary",
          width: "auto",
        },
        {
          label: "资讯分类",
          prop: "category_name",
          width: "80px",
        },
        {
          label: "发布时间",
          prop: "update_time",
          width: "200px",
        },
        {
          label: "状态",
          prop: "status",
          width: "80px",
        },
      ],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      detail: {},
      edit: false,
      doctorTableData: [],
      readForm: {
        read_num: 0,
        info_id: "",
      },
      readDialog: false,
      readFormRules: {
        read_num: [
          { required: true, message: "请输入阅读量", trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    stateText(val) {
      switch (val) {
        case 1:
          return "待发布";
        case 2:
          return "已发布";
        case 3:
          return "已下架";
        default:
          return val;
      }
    },
    typeText(val) {
      switch (val) {
        case 1:
          return "原生";
        case 2:
          return "H5";
        default:
          return val;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    // 状态
    stateStyle(val) {
      switch (val) {
        case 1:
          return { backgroundColor: "#E6A23C" }; // 待发布
        case 2:
          return { backgroundColor: "#1ABC9C" }; // 已发布
        case 3:
          return { backgroundColor: "#FF0000" }; // 已下架
        default:
          return val;
      }
    },
    //获取报表列表
    getList() {
      let params = Object.assign(this.pagination, this.searchForm);
      params = _.omit(params, ["inquiry_time"]);
      let times = this.searchForm.times;
      params["start_time"] = times ? times[0] : "";
      params["end_time"] = times ? times[1] : "";
      imgtext.getDoctorInfoList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.totalNum = data.total;
          if (!data.list.length && this.pagination.page > 1) {
            this.pagination.page = this.pagination.page - 1;
            this.getList();
          } else {
            let list = data.list.map((item) => {
              if (item.update_time) {
                item.update_time = dayjs
                  .unix(item.update_time)
                  .format("YYYY-MM-DD HH:mm");
              } else {
                item.update_time = "待定";
              }
              return item;
            });
            this.doctorTableData = list;
          }
        }
      });
    },
    searchList() {
      this.getList();
    },
    // 阅读量
    readNumClick(data) {
      this.readForm.read_num = data.read_num;
      this.readForm.info_id = data.info_id;
      this.readDialog = true;
    },
    confirmRead() {
      imgtext.changeDoctorInfoReadNum(this.readForm).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("修改成功");
          this.getList();
        }
        this.readDialog = false;
      });
    },
    //排序
    updateSort(data, sort) {
      if (this.totalNum == 1) {
        this.$message.warning("只有一条数据哦");
        return;
      }
      let params = {
        info_id: data.info_id,
        sort,
      };
      imgtext.editDoctorInfoSort(params).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加
    addInfo() {
      this.$router.push({
        path: "/home/imgtext/addInfo",
        query: {
          info_id: -1,
        },
      });
    },
    // 资讯分类
    infoClassifyClick() {
      this.$router.push({
        path: "/home/imgtext/infoClassify",
      });
    },
    // 编辑
    infoEdit(data) {
      let query = _.omit(data, [
        "create_time",
        "is_delete",
        "sort",
        "update_time",
      ]);
      this.$router.push({
        path: "/home/imgtext/addInfo",
        query,
      });
    },
    // 详情
    infoDetail(data) {
      let query = _.omit(data, [
        "create_time",
        "is_delete",
        "sort",
        "update_time",
      ]);
      console.log(data);
      this.$router.push({
        path: "/home/imgtext/addInfo",
        query,
      });
    },
    // 发布/下架
    changeStatus(data, status) {
      let params = Object.assign(_.pick(data, ["info_id"]), { status });
      imgtext.changeDoctorInfoStatus(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success(`${status === 2 ? "发布成功" : "下架成功"}`);
          this.getList();
        }
      });
    },
    // 删除
    infoDel(data) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        imgtext.deleteDoctorInfo({ info_id: data.info_id }).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss">
.doctor-consult {
  .container {
    box-sizing: border-box;
    background-color: #ffffff;
    min-height: calc(100vh - 140px);
    padding: 20px;
    text-align: left;
  }
  .pagination-container {
    display: flex;
    justify-content: center;
  }
  .doctor-table {
    .doctor-status {
      i {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
      }
    }
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
.read-dialog {
  border-radius: 10px;
  .el-dialog__body {
    .el-form-item {
      margin-top: 20px;
      label {
        font-size: 16px;
      }
      .el-form-item__content {
        width: 60%;
      }
    }
    .read-number {
      width: 260px;
    }
  }
}
</style>
